import { render, staticRenderFns } from "./icon-demo.vue?vue&type=template&id=e553f78a&scoped=true"
import script from "./icon-demo.vue?vue&type=script&lang=js"
export * from "./icon-demo.vue?vue&type=script&lang=js"
import style0 from "./icon-demo.vue?vue&type=style&index=0&id=e553f78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e553f78a",
  null
  
)

export default component.exports